<script>
    import {elementDetails} from '../workspacesStore.js';
    import DataTable from '../../DataGrid/DataTable.svelte';
    import MediaColumn from '../../DataGrid/ColumnRenderers/MediaColumn.svelte';
    import {sgettext} from '../../../i18n.js';

    export let rows = $elementDetails ? $elementDetails.keypoints : [];
    let columns = {
        element_slide: {
            label: sgettext('$$MEDIA$$'),
            renderer: MediaColumn,
            width: '160px',
            props : {
                allowAPMEdit : true
            }
        },
        text: {
            label: sgettext('$$KEY_POINT$$'),
            width: '50%'
        },
        reason: {
            label: sgettext('$$REASON$$')
        },
    }
</script>

<DataTable small={true} {columns} {rows} />
